import { ProprieteAffichee, TypePropriete, CustomAffichage } from "./proprieteAffichee";
import { WorkflowModeleProjet } from "./workflowModeleProjet";
import { WorkflowModele } from "./workflowModele";
import { Site } from "./site";
import { Tir } from "./tir";

export class Projet {
  projetId: number;
  nom: string;
  siteId: number;
  dateDebutPrevisionnelle: Date;
  dateFinPrevisionnelle: Date;
  dateDebutEffective: Date;
  dateFinEffective: Date;
  workflowModeleProjet: WorkflowModeleProjet;
  workflowModele: WorkflowModele;
  workflowModeleID: number;
  estTermine: boolean;
  site: Site;
  tirs: Tir[];
  donneeAnalyseRenseignees: boolean;
  usePostgresDatabaseForVibrations: boolean;
  showBlastDesignTab: boolean;
  showBlastLoadTab: boolean;

  getProprietesAffichees() {
    let tab: ProprieteAffichee[] = [];
    tab.push(new ProprieteAffichee('nom', 'GLOBAL.NOM'));
    tab.push(new ProprieteAffichee('estTermine', 'MES_PROJETS.EST_TERMINE', '', new CustomAffichage(TypePropriete.Boolean, 'fas fa-check', '')));
    tab.push(new ProprieteAffichee('dateDebutPrevisionnelle', 'MES_PROJETS.DATE_DEB_PREV', '', new CustomAffichage(TypePropriete.Date, '', '')));
    tab.push(new ProprieteAffichee('dateFinPrevisionnelle', 'MES_PROJETS.DATE_FIN_PREV', '', new CustomAffichage(TypePropriete.Date, '', '')));
    tab.push(new ProprieteAffichee('dateDebutEffective', 'MES_PROJETS.DATE_DEB_EFF', '', new CustomAffichage(TypePropriete.Date, '', '')));
    tab.push(new ProprieteAffichee('dateFinEffective', 'MES_PROJETS.DATE_FIN_EFF', '', new CustomAffichage(TypePropriete.Date, '', '')));
    return tab;
  }
}
